<template>
    <footer @submit="submit">
        <div class="columns">
            <div class="columns_column column" v-html="col1">
            </div>
            <div
                class="columns_column columns_column-2 column column-2"
                v-html="col2">
            </div>
            <div class="columns_column column">
                <h3>Pesquisa:</h3>
                <FooterSearch/>
                <h3>Arquivos</h3>
                <FooterSelect/>
                <h3>Segue-nos e Partilha</h3>
                <div class="social">
                    <a :href="footer.social[social]" v-for="social in socials" :key="social" target="_blank">
                        <img src="../assets/images/facebook.svg" alt="facebook" v-if="social == 'facebook'">
                        <img src="../assets/images/x.svg" alt="twitter" v-if="social == 'twitter'">
                        <img src="../assets/images/youtube.svg" alt="youtube" v-if="social == 'youtube'">
                        <img src="../assets/images/instagram.svg" alt="instagram" v-if="social == 'instagram'">
                        <img src="../assets/images/telegram.svg" alt="telegram" v-if="social == 'telegram'">
                    </a>
                </div>
            </div>
            <ScrollUpButton class="scrollButton"/>
        </div>
        <p><strong>Copyright 2023 BETANO.pt |</strong> todos os direitos reservados</p>
    </footer>
</template>

<script>
    import FooterSelect from './Footer/Select';
    import FooterSearch from './Footer/Search';
    import ScrollUpButton from '../components/ScrollUpButton/ScrollUpButton.vue'
    import api from '@/api';

    export default {
        name: 'FooterComponent',
        components: {
            FooterSelect,
            FooterSearch,
            ScrollUpButton,
        },
        data() {
            return {
                footer: null,
            }
        },
        computed: {
            col1() {
                if( this.footer == null ) {
                    return ''
                }
                return this.footer.section1
            },
            col2() {
                if( this.footer == null ) {
                    return ''
                }
                return this.footer.section2
            },
            socials() {
                if( this.footer == null ) {
                    return []
                }
                return Object.keys(this.footer.social)
            },
        },
        methods: {
            search(value) {
                this.$router.replace({query: {search: value}})
            },
            submit(e) {
                if( e.target.classList.contains("wp-block-search") ) {
                    e.preventDefault()
                    let value = e.target.querySelector("input").value
                    this.search(value)
                }
            },
        },
        async mounted() {
            this.footer = await api.footer.get()
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/colors';
@import '@/assets/scss/queries';
@import '@/assets/scss/fonts';

$font-size: .75rem;

footer {
    --footer-padding: calc(var(--side-padding)) var(--side-padding) calc(var(--side-padding) * 3);
    --footer-content-display: grid;
    --footer-content-grid-template: 
        "up"
        "about"
        "follow"
        "archive"
        ;
    --footer-content-grid-columns: 1fr;

@include media(sm) {
    --footer-padding: 4rem var(--side-padding);
    --footer-content-display: flex;
    --footer-content-grid-template: 
        "about info archive up"
        "about info follow up"
        ;
    --footer-content-grid-columns: min-content 1fr min-content min-content;
}

  width: 100%;
  background-color: $color-betano;

  padding: var(--footer-padding);

  img {
      width: 100%;
      min-width: 0;
  }

  > p {
      margin: 4rem auto 0;
      width: fit-content;
      color: #000;
      font-family: $ff-regular;
      font-size: 0.80388rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: uppercase;

      strong {
          font-weight: 700;
      }
  }
}

    .columns {
        display: var(--footer-content-display);
        justify-content: center;
        gap: calc(var(--content-width) * .05);
        grid-template-areas: var(--footer-content-grid-template);
        grid-template-columns: var(--footer-content-grid-columns);

        &_column {
            flex-basis: 0;
            flex-grow: 1;

            &-2 {
                flex-grow: 2;
            }

            :deep(p) {
                color: $color-white;
                line-height: 2;
                text-align: left;
                font-size: $font-size;
                &:not(:last-child) {
                    margin-bottom: 2em;
                }
            }

            :deep(ul) {
                color: $color-white;
                list-style: none;
                font-size: $font-size;
                li {
                    padding: 1em 0 1em;
                    border-bottom: 2px solid $color-white;
                    display: flex;
                    &::before {
                        content: '';
                        background-image: url('@/assets/images/bullet.svg');
                        height: 1em;
                        width: .35em;
                        display: block;
                        background-size: contain;
                        background-position: center;
                        background-repeat: no-repeat;
                        padding: 0;
                        margin: 0 .5em 0 0;
                    }
                    a {
                        color: $color-white;
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .select {
        font-size: $font-size;
        > a {
            border: 2px solid $color-white;
            padding: 1em;
            display: flex;
            color: $color-white;
            text-decoration: none;
            &::after {
                content: '';
                background-image: url('@/assets/images/bullet.svg');
                height: 1em;
                width: .35em;
                display: block;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                padding: 0;
                margin: 0 0 0 .5em;
                transform: rotate(90deg);
            }
        }
        ul {
            display: none;
        }
    }

    .column {

        :deep(h3) {
            grid-column: 1 / -1;
            margin: 1.5rem 0 1rem;
            color: $color-black;
            font-weight: 900;
            text-transform: uppercase;
            text-align: left;
            font-family: $ff-headings;
        }

        &-2 {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: min-content 1fr;
            gap: 0 3rem;
        }
    }

    .social {
        display: flex;
        gap: 10px;
        justify-content: space-between;

        a {
            height: 20px;
            width: auto;
            display: block;
            transition: .2s ease-out transform;

            &:hover {
                transform: scale(1.15);
            }

            img {
                height: 100%;
                width: auto;
            }
        }
    }

    .scrollButton {
        grid-area: up;
        margin: 0 0 0 auto;
    }

</style>
